<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.dispatch_time="{ item }">
        {{ item.dispatch_time | dateTimeFormat }}
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="notifications.show"
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { dateTimeFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listItems from '@/modules/_global/mixins/list-items';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'NotificationsList',
  components: { ActionSlotComponent },

  filters: {
    dateTimeFormat
  },

  mixins: [i18nRefreshData, listItems],

  data: () => ({}),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('NOTIFICATIONS.SENDING_TIME'),
          value: 'dispatch_time'
        },
        {
          text: this.$t('NOTIFICATIONS.NUMBER_OF_RECIPIENTS'),
          value: 'users_quantity'
        },
        {
          text: this.$t('ITEM.AUTHOR'),
          value: 'author'
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  methods: {}
};
</script>
